import api from "../api/axios";
  

const SupplierService = {
 
    getAllSuppliers: async () => {
        const res = await api.get( "supplier/get-all-suppliers");
        return res.data.data || res.data;
    },
 
    getSupplierById: async (id) => {
        const res = await api.get(`supplier/get-supplier/${id}`);
        return res.data.data || res.data;
    },
 
    addSupplier: async (supplier) => {
        const res = await api.post("supplier/create", supplier);
        return res.data;
    },
 
    updateSupplier: async ( supplier) => {
        const res = await api.post(`/supplier/update`, supplier) 
        return res.data;
    },
 
    deleteSupplier: async (id) => {
        const res = await api.delete(`supplier/delete/${id}`);
        return res.data;
    },
    getSupplierDetail: async (id) => {
        const res = await api.get(`supplier/get-supplier-detail/${id}`);
        return res.data.data || res.data;
    },

    receivePayment: async (paymentDto) => {
        const res = await api.post("supplier/receive-payment", paymentDto);
        return res.data;
    },

    updatePayment: async (paymentDto) => {
        const res = await api.post("supplier/update-payment", paymentDto);
        return res.data;
    },

    deletePayment: async (id) => {
        const res = await api.delete(`supplier/delete-payment/${id}`);
        return res.data;
    },

    saveSupplierPurchaseTransaction: async (purchaseDto) => {
        const res = await api.post(`purchasetransaction/create`, purchaseDto);
        return res.data;
    },

    getPurchaseTransactionDetail: async (id) => {
        const res = await api.get(`purchasetransaction/get-detail/${id}`);
        return res.data;
    },

    updatePurchaseTransaction: async (purchaseDto) => {
        const res = await api.post(`purchasetransaction/update`, { model: purchaseDto });
        return res.data;
    },

    searchProducts: async (params) => {
        const res = await api.get(`product/autocomplete`, params);
        return res.data;
    },

    fastCreateProduct:async (fastProduct) => {
        const res = await api.post(`product/fast-create`, fastProduct);
        return res.data;
    },

    saveSupplierReturn: async (returnDto) => {
        const res = await api.post(`supplier/create-return`, returnDto);
        return res.data;
    },

    deleteReturn: async (id) => {
        const res = await api.delete(`supplier/delete-return/${id}`);
        return res.data;
    },

    createPurchaseReturnFromLine: async (data) => {
        const res = await api.post(`return/create-purchase-return`, data);
        return res.data;
    },

    importExcel: (formData) => api.post("supplier/import-excel", formData, {
        headers: {
            "Content-Type": "multipart/form-data",
        },
    }),

    downloadSample: () => api.get("supplier/download-sample", {
        responseType: "blob",
    }),
};

export default SupplierService;
